'use client';

var ENotificationTypes;
(function (ENotificationTypes) {
    ENotificationTypes[ENotificationTypes["EXPIRE_JOB"] = 1] = "EXPIRE_JOB";
    ENotificationTypes[ENotificationTypes["EMPLOYER_VIEW_PROFILE"] = 3] = "EMPLOYER_VIEW_PROFILE";
    ENotificationTypes[ENotificationTypes["OLD_EMPLOYER_VIEW_PROFILE"] = 4] = "OLD_EMPLOYER_VIEW_PROFILE";
    ENotificationTypes[ENotificationTypes["UNKNOWN_NOTIFY"] = 6] = "UNKNOWN_NOTIFY";
    ENotificationTypes[ENotificationTypes["EMPLOYER_VIEW_APPLICATION"] = 8] = "EMPLOYER_VIEW_APPLICATION";
    ENotificationTypes[ENotificationTypes["EMPLOYER_CHANGE_APPLICATION_STATUS"] = 11] = "EMPLOYER_CHANGE_APPLICATION_STATUS";
    ENotificationTypes[ENotificationTypes["JOB_INVITATION"] = 20] = "JOB_INVITATION";
})(ENotificationTypes || (ENotificationTypes = {}));
var ALLOW_NOTIFY_TYPE = [1, 3, 8, 11, 20];
var EApplicationStatusTypes;
(function (EApplicationStatusTypes) {
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_VIEWED_YOUR_APPLICATION"] = 3] = "EMPLOYER_VIEWED_YOUR_APPLICATION";
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_DECLINED_YOUR_APPLICATION"] = 4] = "EMPLOYER_DECLINED_YOUR_APPLICATION";
    EApplicationStatusTypes[EApplicationStatusTypes["EMPLOYER_SELECTED_YOUR_APPLICATION"] = 6] = "EMPLOYER_SELECTED_YOUR_APPLICATION";
})(EApplicationStatusTypes || (EApplicationStatusTypes = {}));

export { ALLOW_NOTIFY_TYPE, EApplicationStatusTypes, ENotificationTypes };
//# sourceMappingURL=types.js.map
